/* eslint-disable no-param-reassign */

export function parseContactPersons(transaction = {}, contactPersons = []) {
    const invalidCPs = [];

    if (transaction.billing_contact_person_id &&
        !contactPersons.find(cp => cp.id === transaction.billing_contact_person_id)
    ) {
        invalidCPs.push(transaction.autosave_text_values.billing_contact_person_id);
        transaction.billing_contact_person_id = null;
    }

    if (transaction.shipping_contact_person_id &&
        !contactPersons.find(cp => cp.id === transaction.shipping_contact_person_id)
    ) {
        invalidCPs.push(transaction.autosave_text_values.shipping_contact_person_id);
        transaction.shipping_contact_person_id = null;
    }

    return invalidCPs;
}
